import SubcategoryPage from './SubcategoryPage'

export default SubcategoryPage
// eslint-disable-next-line import/export
export * from './SubcategoryPage'
